const queryOptions = (t) => [
  {
    name: 'name',
    displayName: t('chartQueryBuilder.queryOptions.admin.schoolName'),
    type: 'schoolName',
    used: false,
    value: ''
  },
  {
    name: 'shopId',
    displayName: t('chartQueryBuilder.queryOptions.admin.shopId'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'createdAt',
    displayName: t('chartQueryBuilder.queryOptions.admin.date'),
    type: 'date',
    used: false,
    value: ''
  }
];

export default queryOptions;
